namespace appn.dashboards.views.dashboards.create {

    class InitArgs {
        redirectUrl: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs) {
        _initArgs = args;

        if (_initArgs.redirectUrl) {
            appn.location.navTo(_initArgs.redirectUrl);
            return;
        }

        appn.select.init({
            selector: 'select#iconsToDisplay',
            isIconSelect: true
        });
    }
}
